import axios from 'utils/axios';
import { getApiOrigin } from 'utils/apiBaseUrl';

const baseUrl = getApiOrigin();

export const API_URL = `${baseUrl}/api/auth/admin`;
export const TOKEN_URL = `${baseUrl}/api/auth`;

export type LoginPayload = {
  email: string;
  password: string;
};

export type AdminLoginResponseBody = {
  token: string;
  accessToken: string;
  refreshToken: string;
  user?: unknown;
};

export type ChangePasswordPayload = {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
};

export const login = async (payload: LoginPayload): Promise<AdminLoginResponseBody> => {
  const response = await axios.post(`${API_URL}/login`, payload);
  return response.data;
};

export const changePassword = async (payload: ChangePasswordPayload) => {
  const response = await axios.post(`${TOKEN_URL}/change-password`, payload);
  return response.data;
};

export const forgotPassword = async (email: string) => {
  const response = await axios.post(`${TOKEN_URL}/forgot-password`, { email });
  return response.data;
};

export const token = async () => {
  const response = await axios.get(`${TOKEN_URL}/token`);
  return response.data;
};
